module.exports = __webpack_public_path__ + "assets/img/20.579868a9.png";